/**
 * The custom-session wizard's stepper on a phone.
 *
 *   ▬▬▬▬ ▬▬▬▬ ──── ──── ────
 *   STEP 2 OF 5 · YOUR TAGS            10 MATCH
 *
 * The desktop stepper names all five steps in a row with the match chip
 * beside them; at 390 it wrapped onto three lines with the chip as a bubble,
 * ~200px before the first tag. Here the steps are segments, the current one
 * is named, and the match count is one mono word. Jumping back to a step is
 * the Review step's Edit links (and Back), as it already was.
 */

import { cn } from '@ai-tutor/ui';
import type { StepDef } from '@/lib/practice/wizardSteps';

export function WizardPhoneStepper({
  steps,
  currentIndex,
  matchCount,
  isLoading,
}: {
  steps: StepDef[];
  currentIndex: number;
  matchCount: number | null;
  isLoading: boolean;
}) {
  const current = steps[currentIndex];
  return (
    <div className='flex-shrink-0 px-4 pb-3 pt-3'>
      <div aria-hidden='true' className='flex gap-1'>
        {steps.map((s, i) => (
          <span
            key={s.key}
            className={cn(
              'h-1 flex-1 rounded-full transition-colors duration-300',
              i <= currentIndex ? 'bg-foreground' : 'bg-foreground/15'
            )}
          />
        ))}
      </div>
      <div className='mt-2 flex items-center justify-between gap-3 font-mono text-xs font-medium uppercase tracking-[0.1em]'>
        <p className='min-w-0 truncate text-muted-foreground'>
          Step {currentIndex + 1} of {steps.length} ·{' '}
          <span className='text-foreground'>{current?.label}</span>
        </p>
        <p aria-live='polite' className='flex-shrink-0 text-foreground'>
          {isLoading || matchCount == null
            ? ' '
            : `${matchCount.toLocaleString()} match`}
        </p>
      </div>
    </div>
  );
}
